import {
  convertToValidDate,
  isCurrentDateBetween,
} from '@/features/info-top-banner/utils/dates';

interface Props {
  active: boolean;
  visibleFrom: string | null | undefined;
  visibleTo: string | null | undefined;
}

export const useCheckBannerVisibility = ({
  active,
  visibleFrom,
  visibleTo,
}: Props) => {
  const convertedVisibleFrom = convertToValidDate(visibleFrom);
  const convertedVisibleTo = convertToValidDate(visibleTo);

  const isVisibleByDates = isCurrentDateBetween(
    convertedVisibleFrom,
    convertedVisibleTo,
  );

  return isVisibleByDates ? active : false;
};
